import axios, { AxiosResponse } from 'axios';
import { createAxiosConfig } from '../mockHelper';
import { GetNewMembershipInfo, IGetNewMembershipInfoRequest } from '../contracts';

export const GetNewMembershipInfoApi =
  (endpoint: string): GetNewMembershipInfo =>
  async ({ membershipCampaignCode, zipCode, flow, sessionId }: IGetNewMembershipInfoRequest) => {
    try {
      let queryString = '';
      if (sessionId !== undefined) {
        queryString = `?sessionId=${sessionId}`;
      } else if (zipCode !== undefined) {
        queryString = `?zipCode=${zipCode}&flow=${flow}&membershipCampaignCode=${membershipCampaignCode}`;
      }
      const constructedEndpoint = `${endpoint}/${queryString}`;
      const response = await axios.get(constructedEndpoint, createAxiosConfig(null, endpoint));

      return Promise.resolve(response?.data);
    } catch (e: any) {
      const error = e?.response?.data;
      const softError = error?.error?.code;
      if (softError) {
        return Promise.resolve(error);
      }
      return Promise.reject(e);
    }
  };
